import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Text from "@amzn/meridian/text";
import Alert from "@amzn/meridian/alert";
import { keys } from "../../i18n";
import { LOCATION_TYPE } from "../../app-constants";

export default function LocationsValidationAlert({ yardId }) {
  const { t } = useTranslation();
  const { parkingLocations } = useSelector((state) => state.yardConfigData)[yardId];
  const { yardMap } = useSelector((state) => state.yardMapData);

  const missingInMapLocations = parkingLocations
    .filter((location) => !location.offsiteLocation) // exclude offsite locations
    .filter(
      (location) =>
        !yardMap.locations.some(
          (mapLocation) => mapLocation.locationCode.toUpperCase() === location.label.toUpperCase()
        )
    )
    .map((location) => location.label);

  const missingInConfigLocations = yardMap.locations
    .filter((mapLocation) => mapLocation.locationType !== LOCATION_TYPE.GATE) // exclude gates from comparison
    .filter(
      (mapLocation) =>
        !parkingLocations.some(
          (location) => location.label.toUpperCase() === mapLocation.locationCode.toUpperCase()
        )
    );

  if (missingInMapLocations.length === 0 && missingInConfigLocations.length === 0) {
    return null;
  }

  return (
    <>
      {missingInMapLocations.length > 0 && (
        <Alert type="warning" data-testid="missing-from-map-locations-alert">
          <Text type="h100">
            {t(keys.MISSING_IN_MAP_LOCATIONS, { count: missingInMapLocations.length })}
          </Text>
          <span>{t(keys.MISSING_IN_MAP_LOCATIONS_LIST)}</span>
          <div>{missingInMapLocations.join(", ")}</div>
        </Alert>
      )}
      {missingInConfigLocations.length > 0 && (
        <Alert type="warning" data-testid="missing-from-config-locations-alert">
          <Text type="h100">
            {t(keys.MISSING_IN_CONFIG_LOCATIONS, { count: missingInConfigLocations.length })}
          </Text>
        </Alert>
      )}
    </>
  );
}

LocationsValidationAlert.propTypes = {
  yardId: PropTypes.string.isRequired,
};
